import { Input, Select } from 'antd';
import { FormItem } from 'src/components/SharedDetailsComponents';
import styled from 'styled-components';

export const StyledInput = styled(Input)`
  width: 100%;
`;

export const StyledSelect = styled(Select)`
  width: 100%;
`;

export const Wrapper = styled.div`
  padding-bottom: 60px;
`;

export const LabelWrapper = styled.span`
  display: block;
  width: 100%;
`;

interface FormItemProps {
  $isDesktop: boolean;
}

export const StyledFormItem = styled(FormItem)<FormItemProps>`
  grid-column: span 2;
  max-width: ${({ $isDesktop }) => ($isDesktop ? 'calc(50% - 12px)' : '100%')};
`;
